import React, { Component } from 'react';
import { Alert, Spinner, Table, Form, Button, Row, Col, Pagination } from 'react-bootstrap';
import { PageStatus } from 'enums';
import { Show } from "../../Layout";
import CardHeader from "../Card/CardHeader";
import GridContainer from "../Grid/GridContainer";
import { SurveysAPI } from "../../API";
import { reduxForm } from "redux-form";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { FormValue } from "../My Settings/MySettings";

class SurveyStatus extends Component<any, any> {
    private searchTimeout: any = null;

    constructor(props) {
        super(props);
        this.state = {
            status: PageStatus.Loading,
            error: null,
            searchMode: 'project',
            
            page: 1,
            limit: 10,
            total: 0,
            searchQuery: '',
            
            projectData: [],
            clientData: [],
            expandedRows: [], // array of parent surveyId strings
        };
    }

    componentDidMount() {
        this.fetchData(1);
    }

    fetchData = (page = 1) => {
        this.setState({ status: PageStatus.Loading, page, error: null });
        const { searchMode, searchQuery, limit } = this.state;
        
        const params = { page, limit, search: searchQuery };

        if (searchMode === 'project') {
            SurveysAPI.fetchProjectOverviewStatus(params)
                .then((res) => {
                    this.setState({ projectData: res.data || [], total: res.total || 0, status: PageStatus.Loaded });
                })
                .catch((error) => {
                    this.setState({ error: error.message, status: PageStatus.Error });
                });
        } else {
            SurveysAPI.fetchClientOverviewStatus(params)
                .then((res) => {
                    this.setState({ clientData: res.data || [], total: res.total || 0, status: PageStatus.Loaded });
                })
                .catch((error) => {
                    this.setState({ error: error.message, status: PageStatus.Error });
                });
        }
    }

    handleSearchModeChange = (mode) => {
        this.setState({ 
            searchMode: mode, 
            searchQuery: '',
            page: 1,
            total: 0,
            projectData: [], 
            clientData: [],
            error: null,
            expandedRows: []
        }, () => {
            this.fetchData(1);
        });
    };

    handleSearchQueryChange = (e) => {
        const value = e.target.value;
        this.setState({ searchQuery: value });
        
        if (this.searchTimeout) clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.fetchData(1);
        }, 500);
    };

    handlePageChange = (newPage) => {
        this.fetchData(newPage);
    }

    toggleRow = (surveyId) => {
        this.setState(prevState => {
            const isExpanded = prevState.expandedRows.includes(surveyId);
            if (isExpanded) {
                return { expandedRows: prevState.expandedRows.filter(id => id !== surveyId) };
            } else {
                return { expandedRows: [...prevState.expandedRows, surveyId] };
            }
        });
    }

    formatCurrency(value) {
        if (!value && value !== 0) return '$0.00';
        return `$${Number(value).toFixed(2)}`;
    }

    formatDate(dateString) {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString();
    }

    render() {
        const { 
            searchMode, searchQuery, projectData, clientData, status, error,
            page, limit, total, expandedRows
        } = this.state;

        const totalPages = Math.ceil(total / limit);

        return (
            <>
                <GridContainer>
                    <div className='w-100 mb-3'>
                        <CardHeader color="primary">
                            <div className="d-flex align-items-center justify-content-between">
                                <h4>Survey Status Overview</h4>
                            </div>
                        </CardHeader>
                    </div>
                </GridContainer>

                {/* Tabs / Mode Toggles */}
                <div className="mb-4 d-flex justify-content-center">
                    <Button 
                        variant={searchMode === 'project' ? 'primary' : 'outline-primary'} 
                        className="mr-3 px-4 py-2 font-weight-bold" 
                        style={{ borderRadius: '25px', width: '200px' }}
                        onClick={() => this.handleSearchModeChange('project')}
                    >
                        Project Overview
                    </Button>
                    <Button 
                        variant={searchMode === 'client' ? 'primary' : 'outline-primary'} 
                        className="px-4 py-2 font-weight-bold"
                        style={{ borderRadius: '25px', width: '200px' }}
                        onClick={() => this.handleSearchModeChange('client')}
                    >
                        Client Overview
                    </Button>
                </div>

                {/* Main Content Area */}
                <div className="jumbotron bg-transparent p-0" style={{ minHeight: '600px' }}>
                    
                    {/* Search Bar */}
                    <div className="d-flex justify-content-center mb-4">
                        <Form.Control
                            type="text"
                            style={{ maxWidth: '600px', borderRadius: '20px', padding: '10px 20px', border: '1px solid #ccc' }}
                            placeholder={searchMode === 'project' ? 'Search projects...' : 'Search clients...'}
                            value={searchQuery}
                            onChange={this.handleSearchQueryChange}
                        />
                    </div>

                    <Alert variant="danger" show={status === PageStatus.Error}>
                        {error}
                    </Alert>

                    <Show when={status === PageStatus.Loading}>
                        <div className="d-flex justify-content-center w-100 p-5">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    </Show>

                    <Show when={status === PageStatus.Loaded}>
                        {/* PROJECT MODE */}
                        {searchMode === 'project' && (
                            <>
                                {projectData.length === 0 ? (
                                    <Alert variant="info" className="text-center">No projects found.</Alert>
                                ) : (
                                    projectData.map((project, idx) => (
                                        <div key={idx} className="card shadow-sm mb-4 border-0" style={{ borderRadius: '12px', overflow: 'hidden' }}>
                                            <div className="card-header bg-white border-bottom-0 pt-4 pb-0 px-4">
                                                <h5 className="mb-0 text-primary font-weight-bold">{project.name}</h5>
                                            </div>
                                            <div className="card-body p-4">
                                                {/* Metadata Tables */}
                                                <div className="mb-4 d-flex flex-wrap">
                                                    <Table bordered size="sm" style={{ width: '300px', backgroundColor: '#fff', marginBottom: '10px', marginRight: '30px', fontSize: '13px' }}>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ backgroundColor: '#f8f9fa', width: '130px', fontWeight: '500' }}>Survey Start Date</td>
                                                                <td>{this.formatDate(project.startDate)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ backgroundColor: '#f8f9fa', fontWeight: '500' }}>Survey End Date</td>
                                                                <td>{this.formatDate(project.endDate)}</td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>

                                                    <Table bordered size="sm" style={{ width: '300px', backgroundColor: '#fff', marginBottom: '10px', fontSize: '13px' }}>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ backgroundColor: '#f8f9fa', width: '130px', fontWeight: '500' }}>PM Name</td>
                                                                <td>{project.pmName || 'N/A'}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ backgroundColor: '#f8f9fa', fontWeight: '500' }}>Client Name</td>
                                                                <td>{project.clientName || 'N/A'}</td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>

                                                {/* Data Table */}
                                                <div className="table-responsive">
                                                    <Table size="sm" bordered hover className="text-center mb-0" style={{ fontSize: '13px' }}>
                                                        <thead style={{ backgroundColor: '#f1f4f8' }}>
                                                            <tr>
                                                                <th style={{ backgroundColor: '#fff', borderTop: 'none', borderLeft: 'none' }}></th>
                                                                <th>Total Hits</th>
                                                                <th>Terminates</th>
                                                                <th>Security Terminates</th>
                                                                <th>PQ Terminate</th>
                                                                <th>Verisoul Blocked</th>
                                                                <th>Over Quota</th>
                                                                <th>Partner Completes</th>
                                                                <th>Panel Completes</th>
                                                                <th>Total Complete</th>
                                                                <th>CPI</th>
                                                                <th>Revenue</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {/* Parent Aggregate Row */}
                                                            <tr style={{ backgroundColor: expandedRows.includes(project.surveyId) ? '#fdfdfd' : '#fff' }}>
                                                                <td style={{ textAlign: 'left', fontWeight: 'bold', width: '220px' }}>
                                                                    {project.children && project.children.length > 0 ? (
                                                                        <Button 
                                                                            variant="link" 
                                                                            className="p-0 mr-2 text-primary font-weight-bold text-decoration-none" 
                                                                            onClick={() => this.toggleRow(project.surveyId)}
                                                                            style={{ outline: 'none', boxShadow: 'none' }}
                                                                        >
                                                                            {expandedRows.includes(project.surveyId) ? '▼' : '▶'}
                                                                        </Button>
                                                                    ) : <span className="mr-3"></span>}
                                                                    Aggregate Total
                                                                </td>
                                                                <td className="font-weight-bold">{project.totalHits}</td>
                                                                <td className="font-weight-bold">{project.terminates}</td>
                                                                <td className="font-weight-bold">{project.securityTerminates}</td>
                                                                <td className="font-weight-bold">{project.pqTerminate}</td>
                                                                <td className="font-weight-bold">{project.verisoulBlocked ?? 0}</td>
                                                                <td className="font-weight-bold">{project.overQuota}</td>
                                                                <td className="font-weight-bold">{project.partnerCompletes}</td>
                                                                <td className="font-weight-bold">{project.panelCompletes}</td>
                                                                <td className="font-weight-bold">{project.totalComplete}</td>
                                                                <td className="font-weight-bold text-secondary">{this.formatCurrency(project.cpi)}</td>
                                                                <td className="font-weight-bold text-success">{this.formatCurrency(project.revenue)}</td>
                                                            </tr>
                                                            
                                                            {/* Expanded Children Rows */}
                                                            {expandedRows.includes(project.surveyId) && project.children && project.children.map((child, cIndex) => (
                                                                <tr key={cIndex} style={{ backgroundColor: '#fcfcfc' }}>
                                                                    <td style={{ textAlign: 'left', paddingLeft: '40px', color: '#555' }}>
                                                                        ↳ {child.name}
                                                                    </td>
                                                                    <td>{child.totalHits}</td>
                                                                    <td>{child.terminates}</td>
                                                                    <td>{child.securityTerminates}</td>
                                                                    <td>{child.pqTerminate}</td>
                                                                    <td>{child.verisoulBlocked ?? 0}</td>
                                                                    <td>{child.overQuota}</td>
                                                                    <td>{child.partnerCompletes}</td>
                                                                    <td>{child.panelCompletes}</td>
                                                                    <td>{child.totalComplete}</td>
                                                                    <td className="text-secondary">{this.formatCurrency(child.cpi)}</td>
                                                                    <td className="text-success">{this.formatCurrency(child.revenue)}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </>
                        )}

                        {/* CLIENT MODE */}
                        {searchMode === 'client' && (
                            <>
                                {clientData.length === 0 ? (
                                    <Alert variant="info" className="text-center">No clients found.</Alert>
                                ) : (
                                    clientData.map((clientObj, idx) => (
                                        <div key={idx} className="card shadow-sm mb-4 border-0" style={{ borderRadius: '12px' }}>
                                            <div className="card-body p-4">
                                                <h5 className="mb-4 text-primary font-weight-bold">Client: <span className="text-dark">{clientObj.client}</span></h5>
                                                {clientObj.partnerBreakdown?.length > 0 ? (
                                                    <div className="table-responsive">
                                                        <Table bordered size="sm" hover className="mb-0 text-center" style={{ maxWidth: '600px', fontSize: '14px' }}>
                                                            <thead style={{ backgroundColor: '#f1f4f8' }}>
                                                                <tr>
                                                                    <th className="text-left font-weight-bold" style={{ fontSize: '15px' }}>Total Completes Delivered</th>
                                                                    <th className="text-center font-weight-bold" style={{ fontSize: '15px', color: '#1E92C9' }}>{clientObj.totalCompletesDelivered || 0}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {clientObj.partnerBreakdown.map((partner, pIdx) => (
                                                                    <tr key={pIdx}>
                                                                        <td className="text-left pl-3">{partner.partnerName}</td>
                                                                        <td className="text-center font-weight-bold">{partner.totalCompletes}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                ) : (
                                                    <Alert variant="secondary" style={{ maxWidth: '600px' }}>No partner completes found for this client.</Alert>
                                                )}
                                            </div>
                                        </div>
                                    ))
                                )}
                            </>
                        )}
                        
                        {/* Pagination Controls */}
                        {totalPages > 1 && (
                            <div className="d-flex justify-content-center align-items-center mt-5 mb-4">
                                <Button 
                                    variant="outline-primary" 
                                    disabled={page === 1}
                                    onClick={() => this.handlePageChange(page - 1)}
                                    className="mr-4 px-4 rounded-pill"
                                >
                                    &laquo; Previous
                                </Button>
                                <span className="text-muted font-weight-bold">
                                    Page {page} of {totalPages}
                                </span>
                                <Button 
                                    variant="outline-primary" 
                                    disabled={page === totalPages}
                                    onClick={() => this.handlePageChange(page + 1)}
                                    className="ml-4 px-4 rounded-pill"
                                >
                                    Next &raquo;
                                </Button>
                            </div>
                        )}
                    </Show>
                </div>
            </>
        );
    }
}

const SurveyStatusRedux = reduxForm<FormValue, any>({
    form: 'AllPanelists',
})(SurveyStatus);

const mapStateToProps = (state: { adminUser: { adminUser: { phoneNumber: any, email: any, userId: any; token: any; loading: any; error: any; role: any, language:any }; }; }) => {
    return {
        userId: state.adminUser.adminUser.userId,
        role: state.adminUser.adminUser.role,
        phoneNumber: state.adminUser.adminUser.phoneNumber,
        email: state.adminUser.adminUser.email,
        isLoading: state.adminUser.adminUser.loading,
        error: state.adminUser.adminUser.error,
        language: state.adminUser.adminUser.language,
        selectedCountry: state.adminUser.adminUser.selectedCountry,
    };
};

const SurveyStatusWithRouter = withRouter(connect(mapStateToProps)(SurveyStatusRedux));

export { SurveyStatusWithRouter as SurveyStatus };
